import {
  Box,
  HStack,
  Icon,
  NavigationButton,
  Text,
  VStack,
} from '@wegroup/design-system';
import { FlowProductsSidebarItem } from '@flows/src/components/flow-products/FlowProductsSidebar';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { FLOWS_PRODUCTS_PATH } from '@flows/src/FlowsProductsRouter';
import { useFlowProductsOverviewParams } from '@flows/src/hooks/flow-products/useFlowProductsOverviewParams';

interface Props {
  items: FlowProductsSidebarItem[];
}

const FlowProductsSideBarOverviewItems = ({ items }: Props) => {
  const { flowId, tagId } = useFlowProductsOverviewParams();
  const { t } = useTranslation();
  const history = useHistory();

  const handleNavigate = (_tagId: string, index?: number) => {
    const searchParams = new URLSearchParams(window.location.search);
    if (index !== undefined) {
      searchParams.set('index', index.toString());
    } else {
      searchParams.delete('index');
    }

    history.push({
      pathname: `${FLOWS_PRODUCTS_PATH}/${flowId}/overview/${_tagId}`,
      search: searchParams.toString(),
    });
  };

  return (
    <>
      <VStack
        align="flex-start"
        w={{ base: '2xs', laptopL: 'xs' }}
        px="4"
        spacing="2"
      >
        <Text textStyle="normalBodyMedium">
          {t('FLOW_PRODUCTS_SIDEBAR_TITLE')}
        </Text>
        <Text textStyle="smallBody" color="gray.500">
          {t('FLOW_PRODUCTS_SIDEBAR_DESCRIPTION')}
        </Text>
      </VStack>
      <VStack align="stretch" spacing="2" overflowY="auto" pb="4" px="4">
        {items.map((item) => {
          const { iconName, key, subItems } = item;
          const hasSubItems = subItems && subItems.length > 0;

          // Check if any sub-item is active
          const activeSubItem = subItems?.find((subItem) => {
            const searchParams = new URLSearchParams(window.location.search);
            const currentIndex = searchParams.get('index');
            return tagId === key && currentIndex === subItem.index.toString();
          });

          const isMainItemActive = tagId === key && !activeSubItem;

          return (
            <VStack key={key} align="stretch" spacing="0">
              <NavigationButton
                onClick={() => handleNavigate(key)}
                size="md"
                isActive={isMainItemActive}
                variant={'ghost'}
              >
                <HStack spacing="2">
                  {iconName && (
                    <Box
                      color={isMainItemActive ? 'primary.500' : 'gray.500'}
                      transition="0.2s"
                    >
                      <Icon name={iconName} />
                    </Box>
                  )}
                  <Text>{item.label}</Text>
                </HStack>
              </NavigationButton>

              {hasSubItems && (
                <VStack align="stretch" pt="1">
                  {subItems.map((subItem) => {
                    const searchParams = new URLSearchParams(
                      window.location.search,
                    );
                    const currentIndex = searchParams.get('index');
                    const isSubItemActive =
                      tagId === key &&
                      currentIndex === subItem.index.toString();

                    return (
                      <NavigationButton
                        key={subItem.key}
                        onClick={() => handleNavigate(key, subItem.index)}
                        size="sm"
                        isActive={isSubItemActive}
                        pl="10"
                        variant={'ghost'}
                      >
                        <Text fontSize="sm">{subItem.label}</Text>
                      </NavigationButton>
                    );
                  })}
                </VStack>
              )}
            </VStack>
          );
        })}
      </VStack>
    </>
  );
};

export default FlowProductsSideBarOverviewItems;
